import React from 'react'

export const SendMessageSvg = ({ width = 24, height = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd" stroke="#46AAE9" strokeWidth="1.5">
      <path d="M1 21.972c8 .391 12-3.276 12-11.002V2.765" />
      <path d="M5 10l8-8 8 8" />
    </g>
  </svg>
)
